import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramLogo, MapPin } from '@phosphor-icons/react';
import { SERVICE_AREA, CONTACT } from '../../seo/site';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300 pt-14 pb-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="h-8 w-8 rounded-xl bg-amber-600 text-white flex items-center justify-center text-sm font-bold">Z</span>
              <span className="text-lg font-bold text-white">Zimzo</span>
            </div>
            <p className="mb-3 text-sm leading-relaxed max-w-xs">
              Order from your favourite local cafés, restaurants and stores, all in one place.
            </p>
            {/* Same service area on every page - consistent local wording is
                part of what ties the site to Ravangla for search engines. */}
            <p className="flex items-center gap-1.5 mb-4 text-sm text-gray-400">
              <MapPin size={15} weight="bold" />
              Serving {SERVICE_AREA.place} ({SERVICE_AREA.altNames[0]}), {SERVICE_AREA.region} {SERVICE_AREA.postalCode}
            </p>
            <a
              href={CONTACT.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center h-9 w-9 rounded-full bg-gray-800 text-gray-300 hover:bg-amber-600 hover:text-white transition-colors"
              aria-label="Zimzo on Instagram"
            >
              <InstagramLogo size={18} weight="bold" />
            </a>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-400 mb-4">Support</h3>
            <p className="mb-2 text-sm">Questions about an order or a store on Zimzo?</p>
            <Link to="/contact" className="text-sm text-amber-400 hover:text-amber-300 transition-colors">Contact us</Link>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-400 mb-4">Quick Links</h3>
            <nav className="flex flex-col gap-2 text-sm">
              <Link to="/" className="hover:text-amber-400 transition-colors">Home</Link>
              <Link to="/stores" className="hover:text-amber-400 transition-colors">Stores</Link>
              <Link to="/about" className="hover:text-amber-400 transition-colors">About</Link>
              <Link to="/order-history" className="hover:text-amber-400 transition-colors">My Orders</Link>
              <Link to="/profile" className="hover:text-amber-400 transition-colors">My Account</Link>
            </nav>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-center text-gray-500 text-sm">&copy; {year} Zimzo. All rights reserved.</p>
          <nav aria-label="Legal" className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm text-gray-400">
            <Link to="/privacy" className="hover:text-amber-400 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-amber-400 transition-colors">Terms of Service</Link>
            <Link to="/privacy#analytics" className="hover:text-amber-400 transition-colors">Analytics settings</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
